<template>
  <img :src="base_path + encodeURI(src)" :title="title" />
</template>

<script>

export default {
  data () {
    return {

    }
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    base_path () {
      return this.$store.state.avatarBase
    }
  }
}
</script>
